import { WebsocketSpeechRecognition } from './WebhookSpeechRecognition/WebhookSpeechRecognition'
// import { BrowserSpeechRecognition } from './BrowserSpeechRecognition/BrowserSpeechRecognition'

// const hasSpeechRecognition =
//   typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition)

export class TranscriptionService {
  static async start(stream: MediaStream) {
    let speechRecognitionService

    // if (false) {
    //   speechRecognitionService = new BrowserSpeechRecognition()
    //   try {
    //     await speechRecognitionService.start()
    //   } catch (error) {
    //     console.warn('native BrowserSpeechRecognition failed', error)
    //     speechRecognitionService = undefined
    //   }
    // } else {
    //   console.warn('native BrowserSpeechRecognition there is no SpeechRecognition available')
    // }

    if (!speechRecognitionService) {
      speechRecognitionService = new WebsocketSpeechRecognition(stream)
      await speechRecognitionService.start()
    }

    return speechRecognitionService
  }
}
